import React from 'react';
import styled from 'styled-components';

export function LocationAutocomplete({
  onChange,
  onSearch,
  handleAddressSelect,
  value,
  addressList
}) {
  return (
    <>
      <div>
        <Wrapper>
          <label>Shopping at</label>
          <Flex>
            <input
              placeholder="Store name"
              type="text"
              onChange={onChange}
              value={value}
            />
            <Button type="button" onClick={e => onSearch(e)}>
              Search stores
            </Button>
          </Flex>
        </Wrapper>
      </div>
      {addressList && (
        <AddressList>
          <h4>Results</h4>
          {addressList &&
            addressList.map(address => {
              const {
                display_address,
                display_place,
                place_id,
                osm_id
              } = address;
              return (
                <AddressListItem
                  key={`${place_id}${osm_id}`}
                  onClick={e => handleAddressSelect(e, address)}
                >
                  {display_place}
                  <span>{display_address}</span>
                </AddressListItem>
              );
            })}
        </AddressList>
      )}
    </>
  );
}

const AddressList = styled.ul`
  padding: 10px;
  margin: 0;
  margin-top: 10px;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);

  h4 {
    margin-top: 0;
    margin-bottom: 10px;
  }
`;

const AddressListItem = styled.li`
  list-style-type: none;
  margin-bottom: 10px;
  cursor: pointer;
  line-height: 1.5rem;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
  padding: 10px;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 8px;

  span {
    font-size: 0.8rem;
    display: block;
    font-weight: normal;
  }
`;

const Wrapper = styled.div`
  label,
  input {
    display: block;
  }

  label {
    color: #2f2f2f;
    font-weight: bold;
    margin-top: auto;
    margin-bottom: 10px;
  }

  input[type='text'] {
    border: 1px solid black;
    padding: 5px;
    font-size: 1.1rem;
    display: block;
    width: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    box-sizing: border-box;
  }
`;

const Button = styled.button`
  background-color: black;
  color: white;
  border: none;
  font-size: 1rem;
  padding: 5px;
  flex-basis: 30%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const Flex = styled.div`
  display: flex;
`;
